import CustomButton from "@Common/CustomButton"
import { SectionHeaderWrapper } from "./styles"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useOwnerManagment } from "@services"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material"
import { useState } from "react"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export default function SectionHeader() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { getPropertiesWithNoOwnersQuery } = useOwnerManagment()
	const { data: availableProperties, refetch } = getPropertiesWithNoOwnersQuery({ pageNumber: '1', pageSize: '1' })
	const [showNoPropertiesDialog, setShowNoPropertiesDialog] = useState(false)

	const handleAddOwnerClick = async () => {
		// Refetch to get the latest data before checking
		const { data: freshData } = await refetch()
		const propertiesCount = freshData?.data?.result?.length || 0
		
		if (propertiesCount === 0) {
			setShowNoPropertiesDialog(true)
		} else {
			navigate("/add-owner")
		}
	}

	return (
		<SectionHeaderWrapper>
			<div>
				<p>{t('OwnerManagement.Title')}</p>
				<p>{t('OwnerManagement.subTitle')}</p>
			</div>
			<div>
				<CustomButton
					label={t('OwnerManagement.add')}
					withBG
					customPadding='8px 90px'
					onClick={handleAddOwnerClick}
				/>
			</div>
			
			{/* No Properties Dialog */}
			<Dialog
				open={showNoPropertiesDialog}
				onClose={() => setShowNoPropertiesDialog(false)}
				maxWidth="sm"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: '16px',
						padding: '8px'
					}
				}}
			>
				<DialogTitle sx={{ pb: 1 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<InfoOutlinedIcon sx={{ color: '#5B3FFF', fontSize: 28 }} />
						<Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#261B6A' }}>
							{t('OwnerManagement.noPropertiesTitle')}
						</Typography>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Typography sx={{ color: '#6B7280', fontSize: '15px', lineHeight: '24px', mb: 2 }}>
						{t('OwnerManagement.noPropertiesMessage')}
					</Typography>
					<Box sx={{ 
						backgroundColor: '#F3F4F6', 
						padding: '16px', 
						borderRadius: '8px',
						border: '1px solid #E5E7EB'
					}}>
						<Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#374151', mb: 1 }}>
							{t('OwnerManagement.howToProceed')}
						</Typography>
						<Typography sx={{ fontSize: '14px', color: '#6B7280', lineHeight: '20px' }}>
							{t('OwnerManagement.addPropertyFirst')}
						</Typography>
					</Box>
				</DialogContent>
				<DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
					<Button
						onClick={() => setShowNoPropertiesDialog(false)}
						sx={{
							color: '#6B7280',
							textTransform: 'none',
							fontWeight: 500,
							padding: '8px 16px'
						}}
					>
						{t('OwnerManagement.cancel')}
					</Button>
					<Button
						variant="contained"
						onClick={() => {
							setShowNoPropertiesDialog(false)
							navigate('/properties')
						}}
						sx={{
							backgroundColor: '#5B3FFF',
							textTransform: 'none',
							fontWeight: 500,
							padding: '8px 24px',
							borderRadius: '8px',
							'&:hover': {
								backgroundColor: '#4A32CC'
							}
						}}
					>
						{t('OwnerManagement.goToProperties')}
					</Button>
				</DialogActions>
			</Dialog>
		</SectionHeaderWrapper>
	)
}